import React from "react";
import IncrementIcon from "../../Icons/IncrementIcon";
import DecrementIcon from "../../Icons/DecrementIcon";

const ArrowButtons = ({ value, options, updateOption, selectedIndex }) => {
  const optionsLength = options.length;
  let indexOfValue = options.indexOf(value),
    canIncrement = optionsLength - 1 > indexOfValue,
    canDecrement = indexOfValue > 0;

  const incrementVal = () => {
    if (canIncrement) {
      const newIndex = ++indexOfValue,
        newValue = options[newIndex];
      updateOption(newValue);
    }
  };

  const decrementVal = () => {
    if (canDecrement) {
      const newIndex = --indexOfValue,
        newValue = options[newIndex];
      updateOption(newValue);
    }
  };

  let incrementStatus = canIncrement
      ? "dropdown__arrow--enabled"
      : "dropdown__arrow--disabled",
    decrementStatus = canDecrement
      ? "dropdown__arrow--enabled"
      : "dropdown__arrow--disabled";

  return (
    <div className="dropdown__arrows">
      <div
        className={`dropdown__arrow dropdown__arrow--increment ${incrementStatus}`}
        onClick={incrementVal}
      >
        <IncrementIcon />
      </div>

      <div
        className={`dropdown__arrow dropdown__arrow--decrement ${decrementStatus}`}
        onClick={decrementVal}
      >
        <DecrementIcon />
      </div>
    </div>
  );
};

export default ArrowButtons;
